export default {"src":"/uk/_next/static/media/briefcaseIcon.f38a6e69.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};